import React, { useEffect, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import VideoPlayer from "./VideoPlayer";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import ArticleLoader from "../../Common/ArticleLoader";

const SubCategoryPage = () => {
    const { id } = useParams(); // id = pk_sub_cat_key
    const [articles, setArticles] = useState([]);
    const [activePipVideo, setActivePipVideo] = useState(null);
    const [currentlyPlaying, setCurrentlyPlaying] = useState(null);
    const [pageSize, setPageSize] = useState(8);
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [currentSubCategory, setCurrentSubCategory] = useState(null);
    const [subCategories, setSubCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
        const location = useLocation();
    

    const categoryKey = location.state?.categoryKey;
    

    const [isSmallSize, setIsSmallSize] = useState(window.innerWidth < 576);

    // ✅ Handle responsive changes
    useEffect(() => {
        const handleResize = () => setIsSmallSize(window.innerWidth < 576);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // ✅ Fetch subcategories & current subcategory details
    useEffect(() => {
        setPage(1);
        setPageSize(8);
        const getAllSubCategories = async () => {
            try {
                const response = await axios.post(BASE_URL + "API/apicall", {
                    security_key: security_key,
                    mode: "getAllSubCategory",
                });

                const output = response.data;
                setSubCategories(output);

                const subCategory = output.find((sub) => sub.pk_sub_cat_key === id);
                if (subCategory) {
                    setCurrentSubCategory(subCategory);
                    fetchArticles(subCategory.pk_sub_cat_key);
                }
            } catch (error) {
                toast.error("Error fetching subcategories.", { autoClose: 3000 });
            }
        };

        getAllSubCategories();
    }, [id]);

    // ✅ Fetch articles based on subcategory
    const fetchArticles = async (subCatId) => {
        setIsLoading(true);
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getArticlesBySubCategory",
                pk_sub_cat_key: subCatId,
                offset: (page - 1) * pageSize,
                limit: pageSize,
            });

            if (response.data && Array.isArray(response.data.data)) {
                setArticles(response.data.data);
                setTotalCount(response.data.totalCount);
            } else {
                toast.error("Invalid response format.", { autoClose: 3000 });
            }
        } catch (error) {
            toast.error("Error fetching articles.", { autoClose: 3000 });
        } finally {
            setIsLoading(false);
        }
    };

    // ✅ Handle pagination change
    const handleChange = (event, value) => {
        setPage(value);
    };

    useEffect(() => {
        if (currentSubCategory) {
            fetchArticles(currentSubCategory.pk_sub_cat_key);
        }
    }, [page, currentSubCategory]);

    const totalPages = Math.ceil(totalCount / pageSize);

    return (
        <div>
            <main className="mt-15">
                <div className="container">
                    <section className="latest-post mb-30">
                        <h3 className="widget-header widget-header-style-1 font-weight-bold text-center mb-20">
                            {currentSubCategory && (
                                <span className="pl-15 pr-15 font-family-normal">
                                    # {currentSubCategory.subcat_name}
                                </span>
                            )}
                        </h3>

                        {/* ---------- First Row ---------- */}
                        <div className="loop-grid row vertical-divider">
                            {isLoading ? (
                                Array.from({ length: 4 }).map((_, index) => (
                                    <article className="col-lg-3 col-md-6 col-sm-12" key={index}>
                                        <ArticleLoader width={300} />
                                    </article>
                                ))
                            ) : articles && articles.length > 0 ? (
                                articles.slice(0, 4).map((row, index) => (
                                    <ArticleCard
                                        key={index}
                                        row={row}
                                        isSmallSize={isSmallSize}
                                        id={id}
                                        activePipVideo={activePipVideo}
                                        setActivePipVideo={setActivePipVideo}
                                        currentlyPlaying={currentlyPlaying}
                                        setCurrentlyPlaying={setCurrentlyPlaying}
                                        categoryKey={categoryKey}
                                    />
                                ))
                            ) : (
                                <div
                                    className="col-12 text-center d-flex justify-content-center align-items-center"
                                    style={{ height: "350px" }}
                                >
                                    <p className="f-24 mb-0">No articles available</p>
                                </div>
                            )}
                        </div>

                        {/* ---------- Second Row ---------- */}
                        <div className="loop-grid row vertical-divider">
                            {isLoading
                                ? Array.from({ length: 8 }).map((_, index) => (
                                    <article
                                        className="col-lg-3 col-md-6 col-sm-12 d-flex justify-content-center"
                                        key={index}
                                    >
                                        <ArticleLoader width={300} />
                                    </article>
                                ))
                                : articles.slice(4, 8).map((row, index) => (
                                    <ArticleCard
                                        key={index}
                                        row={row}
                                        isSmallSize={isSmallSize}
                                        id={id}
                                        activePipVideo={activePipVideo}
                                        setActivePipVideo={setActivePipVideo}
                                        currentlyPlaying={currentlyPlaying}
                                        setCurrentlyPlaying={setCurrentlyPlaying}
                                        categoryKey={categoryKey}
                                        
                                    />
                                ))}
                        </div>
                    </section>

                    {/* ---------- Pagination ---------- */}
                    <Stack spacing={2} className="my-3 mx-0 px-0">
                        <Pagination count={totalPages} page={page} onChange={handleChange} />
                    </Stack>
                </div>
            </main>
        </div>
    );
};




const ArticleCard = ({
    row,
    isSmallSize,
    id,
    activePipVideo,
    setActivePipVideo,
    currentlyPlaying,
    setCurrentlyPlaying,
    categoryKey
    
}) => (
    <article className="col-lg-3 col-md-6 col-sm-12 d-flex justify-content-center">
        <Link to={`/detail/${row.pk_ac_key}`} state={{ catKey: categoryKey }}>
            <div className="entry-meta meta-0 font-small">
                {row.tag_master &&
                    row.tag_master !== "undefined" &&
                    JSON.parse(row.tag_master).map((item) => (
                        <a key={item.pk_tag_key}>
                            <span className="post-cat position-relative"># {item.tag}</span>
                        </a>
                    ))}
            </div>

            <h5 className="post-title font-weight-bold mb-8">
                {row.ac_name.slice(0, 40) + (row.ac_name.length > 40 ? "..." : "")}
            </h5>
            <p className="excerpt mb-12">{row.ac_summary.slice(0, 180)}</p>

            <figure className="mb-12">
                {row.additionalFields &&
                    row.additionalFields !== "undefined" &&
                    JSON.parse(row.additionalFields).map((item, index) => {
                        if (index === 0) {
                            return item.base_type === "video" ? (
                                <div style={{ height: "200px" }} key={index}>
                                    <VideoPlayer
                                        src={IMAGE_URL + item.file_name}
                                        activePipVideo={activePipVideo}
                                        setActivePipVideo={setActivePipVideo}
                                        currentlyPlaying={currentlyPlaying}
                                        setCurrentlyPlaying={setCurrentlyPlaying}
                                    />
                                </div>
                            ) : (
                                <img
                                    key={index}
                                    className={isSmallSize ? "img-fluid w-100" : "img-sm-fluid w-100"}
                                    src={IMAGE_URL + item.file_name}
                                    alt=""
                                    height={200}
                                    style={{ height: "200px" }}
                                />
                            );
                        }
                        return null;
                    })}
            </figure>

            <div className="entry-meta meta-2 text-uppercase font-x-small color-muted">
                {row.author_info &&
                    JSON.parse(row.author_info).map((item, index) => (
                        <span key={index}>
                            <a className="float-left mr-10 author-img">
                                <img src={IMAGE_URL + item.profile} alt="" />
                            </a>
                            By
                            <a>
                                <span className="author-name">
                                    {item.first_name + " " + item.last_name}
                                </span>
                            </a>
                            <span className="create-date ml-30">{row.mod_publish_date}</span>
                        </span>
                    ))}
                <div className="horizontal-divider mt-16 mb-8"></div>
            </div>
        </Link>
    </article>
);

export default SubCategoryPage;
